<template>
    <div
        :id="id"
        class="block lg:hidden"
    ></div>
</template>

<script setup lang="ts">
    const props = defineProps({
        id: {
            type: String,
            required: true,
        },
    })
</script>
